module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.options,
      "show-all-levels": _vm.showalllevels,
      "filterable": _vm.filterable,
      "props": {
        expandTrigger: 'hover',
        checkStrictly: _vm.checkStrictly,
        children: 'childData',
        label: 'dictName',
        value: 'dictId'
      },
      "clearable": "",
      "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return',
      "placeholder": '请选择' + _vm.placeholderLoad
    },
    on: {
      "change": _vm.handleChange,
      "blur": _vm.handleblur,
      "visible-change": _vm.visibleChange
    },
    model: {
      value: (_vm.values),
      callback: function($$v) {
        _vm.values = $$v
      },
      expression: "values"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-726e1ad4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/Sass/components/Cascader.vue
// module id = 1335
// module chunks = 5